import React from 'react'
import { UrlLoader } from './UrlLoader'
import { useRouteParam } from '../browser/useRouteParam'

export const UrlRouteLoader: React.FC = () => {
  const urlToken = useRouteParam('urlToken')
  return <UrlLoader urlToken={urlToken} />
}
